import { render, staticRenderFns } from "./acesso.vue?vue&type=template&id=36a4f449&scoped=true"
import script from "./acesso.vue?vue&type=script&lang=js"
export * from "./acesso.vue?vue&type=script&lang=js"
import style0 from "./acesso.vue?vue&type=style&index=0&id=36a4f449&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a4f449",
  null
  
)

export default component.exports